var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDailyAluxReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4C8 6.20914 6.20914 8 4 8C1.79085 8 0 6.20914 0 4C0 1.79085 1.79085 0 4 0C6.20914 0 8 1.79085 8 4ZM3.53732 6.11797L6.50506 3.15023C6.60584 3.04945 6.60584 2.88605 6.50506 2.78527L6.14011 2.42032C6.03934 2.31953 5.87594 2.31953 5.77514 2.42032L3.35484 4.84061L2.22485 3.71063C2.12408 3.60985 1.96068 3.60985 1.85989 3.71063L1.49494 4.07558C1.39416 4.17635 1.39416 4.33976 1.49494 4.44053L3.17235 6.11795C3.27315 6.21874 3.43653 6.21874 3.53732 6.11797Z",
    fill: "#022C43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDailyAluxReady);
export default __webpack_public_path__ + "static/media/icon-daily-alux-ready.f51aa21ce9e4cb3a995a061afdeab1b2.svg";
export { ForwardRef as ReactComponent };